import { State } from 'redux/types';

export const entitiesSelector = (state: State) => state.get('entities');
